export default () => ({
    list: [],
    byId: {},
    allIds: [],
});
